import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {Formik, FormikProps} from 'formik';
import BaseForm, {FormValues} from './private/CreateTeamFormBase';
// import {TeamsModelType} from '../../models/TeamsModel';

// interface WithInjectedProps {
//   // teams: TeamsModelType;
// }

@inject('teams')
@observer
export default class CreateTeamForm extends React.Component<{}, {}> {
  public render() {
    // const loading = this._withInjectedProps.teams.isCreatingTeam;

    return (
      <Formik
        initialValues={this._initialValues}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => (
          <BaseForm {...props} loading={false} />
        )}
      />
    );
  }

  private get _initialValues() {
    return {email: '', name: '', about: ''};
  }

  private get _validationSchema() {
    return Yup.object().shape({
      name: Yup.string().required('Please enter your team name.'),
      email: Yup.string()
        .email('E-mail is not valid.')
        .required('Please enter your email.')
    });
  }

  private _handleSubmit = ({name, email, about}: FormValues) => {
    // this._withInjectedProps.teams.createTeam({name, email, about});
  };

  // private get _withInjectedProps() {
  //   return this.props as WithInjectedProps;
  // }
}



// WEBPACK FOOTER //
// ./src/containers/CreateTeamForm/CreateTeamForm.tsx